import Blockly from "blockly";


// 列表类型积木
// 列表长度
Blockly.Blocks["lists_length"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e%{BKY_LISTS_LENGTH_TITLE}",
            args0: [{
                type: "input_value",
                name: "VALUE",
                check: ["String", "Array"]
            }],
            output: "Number",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_LENGTH_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_LENGTH_HELPURL}"
        });
    }
};
// 空列表
Blockly.Blocks["lists_isEmpty"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e%{BKY_LISTS_ISEMPTY_TITLE}",
            args0: [{
                type: "input_value",
                name: "VALUE",
                check: ["String", "Array"]
            }],
            output: "Boolean",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_ISEMPTY_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_ISEMPTY_HELPURL}"
        });
    }
};


Blockly.Blocks["lists_create_with"] = {
    /**
     * Block for creating a list with any number of elements of any type.
     * @this {Blockly.Block}
     */
    init: function() {
        this.setHelpUrl(Blockly.Msg["LISTS_CREATE_WITH_HELPURL"]);
        this.setStyle("list_blocks");
        this.itemCount_ = 3;
        this.updateShape_();
        this.setOutput(true, "Array");
        this.setInputsInline(true);
        this.setMutator(new Blockly.Mutator(["lists_create_with_item"]));
        this.setTooltip(Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"]);
    },
    /**
     * Create XML to represent list inputs.
     * @return {!Element} XML storage element.
     * @this {Blockly.Block}
     */
    mutationToDom: function() {
        var container = Blockly.utils.xml.createElement("mutation");
        container.setAttribute("items", this.itemCount_);
        return container;
    },
    /**
     * Parse XML to restore the list inputs.
     * @param {!Element} xmlElement XML storage element.
     * @this {Blockly.Block}
     */
    domToMutation: function(xmlElement) {
        this.itemCount_ = parseInt(xmlElement.getAttribute("items"), 10);
        this.updateShape_();
    },
    /**
     * Populate the mutator's dialog with this block's components.
     * @param {!Blockly.Workspace} workspace Mutator's workspace.
     * @return {!Blockly.Block} Root block in mutator.
     * @this {Blockly.Block}
     */
    decompose: function(workspace) {
        var containerBlock = workspace.newBlock("lists_create_with_container");
        containerBlock.initSvg();
        var connection = containerBlock.getInput("STACK").connection;
        for (var i = 0; i < this.itemCount_; i++) {
            var itemBlock = workspace.newBlock("lists_create_with_item");
            itemBlock.initSvg();
            connection.connect(itemBlock.previousConnection);
            connection = itemBlock.nextConnection;
        }
        return containerBlock;
    },
    /**
     * Reconfigure this block based on the mutator dialog's components.
     * @param {!Blockly.Block} containerBlock Root block in mutator.
     * @this {Blockly.Block}
     */
    compose: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock("STACK");
        // Count number of inputs.
        var connections = [];
        while (itemBlock) {
            connections.push(itemBlock.valueConnection_);
            itemBlock =
                itemBlock.nextConnection && itemBlock.nextConnection.targetBlock();
        }
        // Disconnect any children that don't belong.
        for (var i = 0; i < this.itemCount_; i++) {
            var connection = this.getInput("ADD" + i).connection.targetConnection;
            if (connection && connections.indexOf(connection) == -1) {
                connection.disconnect();
            }
        }
        this.itemCount_ = connections.length;
        this.updateShape_();
        // Reconnect any child blocks.
        for (let i = 0; i < this.itemCount_; i++) {
            Blockly.Mutator.reconnect(connections[i], this, "ADD" + i);
        }
    },
    /**
     * Store pointers to any connected child blocks.
     * @param {!Blockly.Block} containerBlock Root block in mutator.
     * @this {Blockly.Block}
     */
    saveConnections: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock("STACK");
        var i = 0;
        while (itemBlock) {
            var input = this.getInput("ADD" + i);
            itemBlock.valueConnection_ = input && input.connection.targetConnection;
            i++;
            itemBlock =
                itemBlock.nextConnection && itemBlock.nextConnection.targetBlock();
        }
    },
    /**
     * Modify this block to have the correct number of inputs.
     * @private
     * @this {Blockly.Block}
     */
    updateShape_: function() {
        if (this.itemCount_ && this.getInput("EMPTY")) {
            this.removeInput("EMPTY");
        } else if (!this.itemCount_ && !this.getInput("EMPTY")) {
            this.appendDummyInput("EMPTY").appendField(
                Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"]
            );
        }
        // Add new inputs.
        for (var i = 0; i < this.itemCount_; i++) {
            if (!this.getInput("ADD" + i)) {
                var input = this.appendValueInput("ADD" + i);
                if (i == 0) {
                    input.appendField(Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"]);
                }
            }
        }
        // Remove deleted inputs.
        while (this.getInput("ADD" + i)) {
            this.removeInput("ADD" + i);
            i++;
        }
    }
};

Blockly.Blocks["lists_establish_with"] = {
    /**
     * Block for creating a list with any number of elements of any type.
     * @this {Blockly.Block}
     */
    init: function() {
        this.setHelpUrl(Blockly.Msg["LISTS_CREATE_WITH_HELPURL"]);
        this.setStyle("list_blocks");
        this.itemCount_ = 3;
        this.updateShape_();
        this.setOutput(true, "Array");
        this.setInputsInline(true);
        this.setMutator(new Blockly.Mutator(["lists_create_with_item"]));
        this.setTooltip(Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"]);
    },
    /**
     * Create XML to represent list inputs.
     * @return {!Element} XML storage element.
     * @this {Blockly.Block}
     */
    mutationToDom: function() {
        var container = Blockly.utils.xml.createElement("mutation");
        container.setAttribute("items", this.itemCount_);
        return container;
    },
    /**
     * Parse XML to restore the list inputs.
     * @param {!Element} xmlElement XML storage element.
     * @this {Blockly.Block}
     */
    domToMutation: function(xmlElement) {
        this.itemCount_ = parseInt(xmlElement.getAttribute("items"), 10);
        this.updateShape_();
    },
    /**
     * Populate the mutator's dialog with this block's components.
     * @param {!Blockly.Workspace} workspace Mutator's workspace.
     * @return {!Blockly.Block} Root block in mutator.
     * @this {Blockly.Block}
     */
    decompose: function(workspace) {
        var containerBlock = workspace.newBlock("lists_create_with_container");
        containerBlock.initSvg();
        var connection = containerBlock.getInput("STACK").connection;
        for (var i = 0; i < this.itemCount_; i++) {
            var itemBlock = workspace.newBlock("lists_create_with_item");
            itemBlock.initSvg();
            connection.connect(itemBlock.previousConnection);
            connection = itemBlock.nextConnection;
        }
        return containerBlock;
    },
    /**
     * Reconfigure this block based on the mutator dialog's components.
     * @param {!Blockly.Block} containerBlock Root block in mutator.
     * @this {Blockly.Block}
     */
    compose: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock("STACK");
        // Count number of inputs.
        var connections = [];
        while (itemBlock) {
            connections.push(itemBlock.valueConnection_);
            itemBlock =
                itemBlock.nextConnection && itemBlock.nextConnection.targetBlock();
        }
        // Disconnect any children that don't belong.
        for (var i = 0; i < this.itemCount_; i++) {
            var connection = this.getInput("ADD" + i).connection.targetConnection;
            if (connection && connections.indexOf(connection) == -1) {
                connection.disconnect();
            }
        }
        this.itemCount_ = connections.length;
        this.updateShape_();
        // Reconnect any child blocks.
        for (let i = 0; i < this.itemCount_; i++) {
            Blockly.Mutator.reconnect(connections[i], this, "ADD" + i);
        }
    },
    /**
     * Store pointers to any connected child blocks.
     * @param {!Blockly.Block} containerBlock Root block in mutator.
     * @this {Blockly.Block}
     */
    saveConnections: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock("STACK");
        var i = 0;
        while (itemBlock) {
            var input = this.getInput("ADD" + i);
            itemBlock.valueConnection_ = input && input.connection.targetConnection;
            i++;
            itemBlock =
                itemBlock.nextConnection && itemBlock.nextConnection.targetBlock();
        }
    },
    /**
     * Modify this block to have the correct number of inputs.
     * @private
     * @this {Blockly.Block}
     */
    updateShape_: function() {
        if (this.itemCount_ && this.getInput("EMPTY")) {
            this.removeInput("EMPTY");
        } else if (!this.itemCount_ && !this.getInput("EMPTY")) {
            this.appendDummyInput("EMPTY").appendField(
                Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"]
            );
        }
        // Add new inputs.
        for (var i = 0; i < this.itemCount_; i++) {
            if (!this.getInput("ADD" + i)) {
                var input = this.appendValueInput("ADD" + i);
                if (i == 0) {
                    input.appendField(Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"]);
                }
            }
        }
        // Remove deleted inputs.
        while (this.getInput("ADD" + i)) {
            this.removeInput("ADD" + i);
            i++;
        }
    }
};

//列表类型积木
Blockly.Blocks.gta_ai_lists_include = {
    init: function() {
      this.appendDummyInput()
        .appendField(' ')
        .appendField(new Blockly.FieldTextInput('0'), 'NAME')
        .appendField(' ')
      this.appendDummyInput()
        .appendField(
          new Blockly.FieldDropdown([
            ['存在于', 'in'],
            ['不存在于', 'not in'],
          ]),
          'NAME1'
        )
        .appendField(' ')
      this.appendValueInput('NAME2').setCheck('Array')
      this.appendDummyInput().appendField(' ')
      this.setInputsInline(true)
      this.setOutput(true, 'Boolean')
      this.setStyle('list_blocks')
      this.setTooltip('')
      this.setHelpUrl(Blockly.Msg['GAT_AI_LISTS_INCLUDE_HELPURL'])
    },
  }
  
  Blockly.Python.gta_ai_lists_include = function(a) {
    var str = a.getFieldValue('NAME')
    var dropdown = a.getFieldValue('NAME1')
    var bvalue = Blockly.Python.valueToCode(
      a,
      'NAME2',
      Blockly.Python.ORDER_ATOMIC
    )
    // TODO: Assemble JavaScript into code variable.
    var code = '(' + str + ' ' + dropdown + ' ' + bvalue + ')'
    // TODO: Change ORDER_NONE to the correct strength.
    return [code, Blockly.Python.ORDER_NONE]
  }
  
  //列表类型积木
  Blockly.Blocks.gta_ai_lists_include_2 = {
    init: function() {
      this.appendDummyInput()
        .appendField(' ')
        this.appendValueInput('NAME').setCheck(null)
      //   .appendField(new Blockly.FieldTextInput('0'), 'NAME')
      this.appendDummyInput()
      .appendField(' ')
      this.appendDummyInput()
        .appendField(
          new Blockly.FieldDropdown([
            ['存在于', 'in'],
            ['不存在于', 'not in'],
          ]),
          'NAME1'
        )
        .appendField(' ')
      this.appendValueInput('NAME2').setCheck('Array')
      this.appendDummyInput().appendField(' ')
      this.setInputsInline(true)
      this.setOutput(true, 'Boolean')
      this.setStyle('list_blocks')
      this.setTooltip('')
      this.setHelpUrl(Blockly.Msg['GAT_AI_LISTS_INCLUDE_2_HELPURL'])
    },
  }
  
  Blockly.Python.gta_ai_lists_include_2 = function(a) {
    // var str = a.getFieldValue('NAME')
    var str= Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
    var dropdown = a.getFieldValue('NAME1')
    var bvalue = Blockly.Python.valueToCode(
      a,
      'NAME2',
      Blockly.Python.ORDER_ATOMIC
    )
    // TODO: Assemble JavaScript into code variable.
    var code = '(' + str + ' ' + dropdown + ' ' + bvalue + ')'
    // TODO: Change ORDER_NONE to the correct strength.
    return [code, Blockly.Python.ORDER_NONE]
  }